import { get /*, post, put*/, post } from "./axiosApi";
import { env } from "utils/env";

const url = env.REACT_APP_LEASING_API_URL; //"http://kube-w1:32751/api";

class UserApi {
  static loadUserInfo() {
    return get(url + "/user/info");
  }
  
  static resetUserCache() {
    return post(url + "/user/reset-user-cache", {});
  }
}

export default UserApi;
